import styled from 'styled-components';
import { Row as BaseRow } from '../../styles';

export const Row = styled(BaseRow).withConfig({ displayName: 'ContentPromotionGoalsDialogRow' })`
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: var(--background-secondary);
    }

    &:last-child {
        padding-bottom: 24px;
    }
`;
